import { Component, ViewChild, ElementRef,HostListener, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import{ NavController, ActionSheetController,AlertController,Events,IonTabs,MenuController,ModalController,Platform,PopoverController} from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { NativeService } from 'src/service/native.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute,Router} from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { Device } from '@ionic-native/device/ngx';
import { EmitserviceService } from 'src/service/emitservice.service';
import {WxjssdkService} from 'src/service/wxjssdk.service';
import {PublicselectionPage} from '../../../publicselection/publicselection.page';
import {SelectionpagePage} from '../../../selectionpage/selectionpage.page';
import { ListofActivitiesPage } from '../../listof-activities/listof-activities.page'
import { typeWithParameters } from '@angular/compiler/src/render3/util';
declare var app;
@Component({
  selector: 'app-a2-sample-gift-selection',
  templateUrl: './a2-sample-gift-selection.component.html',
  styleUrls: ['./a2-sample-gift-selection.component.scss']
})
export class A2SampleGiftSelectionComponent extends GridBaseCase implements AfterViewInit   {
  @ViewChild('qrcode') qrcode: ElementRef;
  FK_TBActivity_ID: any = null;
  DisabledSubmit: boolean = false;
  isFormActivity:boolean = true;
  selectVal:any = null;
  milkActivity:any = null;
  tempGridList:Array<any>=new Array<any>();//礼品/样品列表
  tempGridgifList:Array<any>=new Array<any>();// 样品列表
  ischeckAll:boolean=false;//是否返回权限
  ischeckAllg:boolean=false; //是否 样品返回全选
  activityListArray:Array<any> = new Array<any>();//活动名称列表
  lpArrayList:Array<any>=[];//礼品列表
  // logisticsCode:Array<string>=new Array<string>();//缓存罐码
  activityName:any="请选择活动";
  activityID:string=null;//选择的活动ID
  info:any={};
  infoName:any;
  infoNametext:any;
  infoPhon:any;
  infoPhontext:any;
  createtimeval:any;
  createtimetex:any;
  modifytime:any;
  modifytimetext:any;
  searchval:any;
  searchtex:any;
  type1:any;
  type1text:any;
  type2:any;
  type2text:any;
  type3:any;
  type3text:any;
  type4:any;
  type4text:any;
  typeall:any=[];//所有用户标签
  a_TelPhone:any; // 手机号
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public native: NativeService,
    public alertCtrl:AlertController,
    public modalCtrl:ModalController,
    public menuCtrl:MenuController,
    public actionSheetCtrl:ActionSheetController,
    public popoverCtrl:PopoverController,
    private alertController: AlertController,
    private barcode: BarcodeScanner,
    private device:Device,
    private router:Router,
    private weixin:WxjssdkService
  ) { super(); 
    this.baseService.FixedSubmitBtn.configName = "SampleGiftSelection";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "下一步";
    this.baseService.FixedSubmitBtn.type = 9;
    this.base.GridListCount=0;
    this.base.GridGiftCount=0;
    this.base.GridGiftNumber=0;
    this.baseService.FixedSubmitBtn["GridListCount"] = this.base.GridListCount;
    const _id = this.activaRouter.snapshot.paramMap.get('id');
    if(_id && _id.split("&")[0]){
      this.FK_TBActivity_ID = _id.split("&")[0];
      this.isFormActivity = true;
      if(_id.split("&")[1]){
        this.milkActivity = _id.split("&")[1];
      }
    }
   
  }

  ngAfterViewInit(){
    // debugger;
   
    console.log("会员会员数据数据数据")
    console.log(this.com.GetStorageKey("meminfo"));
    const that =this;
    
    if(that.com.GetStorageKey("meminfo")!=null){
      that.info = that.com.GetStorageKey("meminfo");
      that.infoName = that.info.name.value;
      that.infoNametext = that.info.name.text;
      that.infoPhon=that.info.phone.value;
      that.infoPhontext=that.info.phone.text;
      if(that.info.a_TelPhone){
        that.a_TelPhone = that.info.a_TelPhone.value;
      }
      if(that.info.phones){
        that.a_TelPhone =that.info.phones.value.toString();
      }

      if(that.info.modifytime){
        that.modifytimetext=that.info.modifytime.text;
        that.modifytime=that.info.modifytime.value.replace(/-/g,"/").replace("T"," ");
      }
      
      if(that.info.createtime){
        that.createtimeval =that.info.createtime.value.replace(/-/g,"/").replace("T"," ");
        that.createtimetex =that.info.createtime.text;
      }
      

      // that.searchval=  that.info.search.value;
      // that.searchtex = that.info.search.text;
    if(that.info.type1){
      that.type1 = that.info.type1.value;
      that.type1text = that.info.type1.text;
    }
     
     if(that.info.type2){
      that.type2 = that.info.type2.value;
      that.type2text = that.info.type2.text;
     }
      
  if(that.info.type3){
    that.type3 = that.info.type3.value;
    that.type3text = that.info.type3.text;
  }
     
if(that.info.type4){
  that.type4 = that.info.type4.value;
  that.type4text = that.info.type4.text;
}
      
      if(that.info&&that.info.typeall)
      {
        that.typeall=that.info.typeall.value||[];
      }
      console.log( that.infoNametext)

      console.log(  that.infoName)
    }
    if(that.info.info1){
      if(that.info.info1.value){
        that.info.info1.value=that.info.info1.value.split(",");
      }
      
    }
   
    that.BindActivityInfo();
    
    /**
     * milkActivity 奶卡活动入口进来
     * mmbActivity 妈妈班活动入口进来
     * 自动弹出选择扫码方式
     */
    // if(this.milkActivity && (this.milkActivity == "milkActivity" || this.milkActivity == "mmbActivity")){
    //   // this.qrCodeClick();
    // }
  }

  /**
   * 选择值
   * @param event 
   */
  changeSelect(event) {
    let that = this;
    console.log(event.detail.value);
    if (event.detail.value == "无") {
      this.FK_TBActivity_ID = null;
    } else {
      this.FK_TBActivity_ID = event.detail.value;
    }
    that.selectVal = "";
    this.baseService.ListData.forEach(item=>{
      item.isCheck = false;
      if(that.FK_TBActivity_ID == item.id){
        item.isCheck = true;
        that.selectVal = item.text;
      }
    })
    if(!that.selectVal){
      that.selectVal = "扫码销量";
    }
  }
  /**
   * 数量改变事件
   * @param item 
   */
  onInput(item) {
    console.log(item);
    this.baseService.FixedSubmitBtn["GridListCount"] = this.base.GridListCount;
  }
  /**
   * 礼品/样品值变化
   * @param item 
   */
  onInputChanage(item,e){
    const that =this;
    console.log(e,"值的变化");
    let _value="";
    if(e.target.value.trim()){
      _value=e.target.value;
    }else{
      _value="0";
    }
      item.Num=that.com.GetNumber(_value);
    let temoCount:number = 0;
    that.tempGridList.forEach(t=>{
      temoCount+=t.Num;
    });
    e.target.value=item.Num;
    that.base.GridGiftCount = temoCount;
  }
  /**
   * 
   * @param PageNumber 
   * 样品选择
   */
  onInputChanage1(item,e){
    const that =this;
    console.log(e,"值的变化");
    let _value="";
    if(e.target.value.trim()){
      _value=e.target.value;
    }else{
      _value="0";
    }
      item.Num=that.com.GetNumber(_value);
    let temoCount:number = 0;
    that.tempGridgifList.forEach(t=>{
      temoCount+=t.Num;
    });
    e.target.value=item.Num;
    
    that.base.GridGiftNumber = temoCount;
  }
  LoadData(PageNumber) {
    let that = this;
    console.log("load");
    if( that.com.GetStorageKey("activityName")){
      that.activityName = that.com.GetStorageKey("activityName").activityName;
      that.activityID=that.com.GetStorageKey("activityName").activityID;
    }
   
    
    // if(that.com.GetStorageKey("homing") && this.com.GetAccount.BuType== "GTBBS"){
    //   that.com.removeItem(["homing"]);
    //   that.tempGridList = that.com.GetStorageKey("homing");
    // }
    // if(that.com.GetStorageKey("product") && this.com.GetAccount.BuType== "GTBBS"){
    //   that.com.removeItem(["product"]);
    // }
        if(that.com.GetStorageKey("homing")){
          that.tempGridList = that.com.GetStorageKey("homing");
          
        }
        if(that.com.GetStorageKey("lpArrayList")){
          that.lpArrayList = that.com.GetStorageKey("lpArrayList");
        }
        
  }
  /**
   * 选择的值的变化
   * @param event 
   */
  changeSelectActive(event){
    const that =this;
    if (!event.detail.value) {
      this.activityID = null;
    } else {
      this.activityID = event.detail.value;
    }
    that.activityName = "";
    that.activityListArray.forEach(item=>{
      if(that.activityID == item.a_ID){
        that.activityName = item.a_Name;
      }
    })
    if(!that.activityName){
      that.activityName = "扫码销量";
    }
  }
  // 取消选项清空
  clearActive(){

  }
  /**
   * 获取活动列表
   */
  BindActivityInfo(){
    const that =this;
    that.activityListArray=[];
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "GetActivityList";
    body.OpType = "query";
    body.ConfigType = "form";
    // body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 0;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 0;
    console.log(that.a_TelPhone)
    // body.RequestBody={"telPhone":that.a_TelPhone};
    // let _obj={};
    // _obj["telPhone"] = that.a_TelPhone;
    // body.RequestBody = JSON.stringify(_obj);
    body.RequestBody = JSON.stringify({"telPhone": that.a_TelPhone})
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
       that.activityListArray=data.Status.Datas||[];
      } else {
        console.log(data.ResponseMessage.ErrorMessage,"拉去活动列表失败");
      }
    }).catch(error => {
    console.log(error,"拉去活动列表失败");
    });
  }
  /**
   * 下一步
   */
  EventClick() {
    const that = this;
    console.log("扫描销量");
    console.log(that.base.GridArrayData);
    that.baseService.FixedSubmitBtn.isSubmitData = true;
    console.log(that.tempGridList)
    // if(that.tempGridList.length<= 0){
    //   that.baseService.FixedSubmitBtn.isSubmitData = false;
    //   that.msg.Alert("请选择会员礼");
    //   return;
    // }
    console.log(that.activityID,"0000000id")
    if(that.tempGridList.length>0){
        localStorage.setItem("homing",JSON.stringify(that.tempGridList));
    }
    
    if(that.lpArrayList.length>0){
      localStorage.setItem("lpArrayList",JSON.stringify(that.lpArrayList));
  }
  if(that.info.typeinfoType && that.tempGridList.length<=0){
      that.msg.Confirm("该会员还未选择会员礼品，您是否确认要进行下一步操作？如果点击继续，代表已与会员确认，放弃会员礼","返回","继续").then(res=>{
        if(res){
          that.com.setHistoryUrl();
          // debugger;
          // that.router.navigate(["/tabs/contact/ScanningHoming/view/" + this.com.getNowDatetime], {
          //   queryParams: {
          //     FK_TBActivity_ID:that.activityID,
          //     activityName:that.activityName
          //   }
          // });
          // let _obj = {
          //   activityName:that.activityName,
          //   activityID:that.activityID
          // }
          // localStorage.setItem("activityName",JSON.stringify(_obj));
          
          that.com.Go("/tabs/contact/ScanningHoming/view/" + this.com.getNowDatetime,{
            FK_TBActivity_ID:that.activityID,
            activityName:that.activityName
          })
        }
      })
      return;
  }else{
    that.com.setHistoryUrl();
    // debugger;
    // that.router.navigate(["/tabs/contact/ScanningHoming/view/" + this.com.getNowDatetime], {
    //   queryParams: {
    //     FK_TBActivity_ID:that.activityID,
    //     activityName:that.activityName
    //   }
    // });
    // let _obj = {
    //   activityName:that.activityName,
    //   activityID:that.activityID
    // }
    // localStorage.setItem("activityName",JSON.stringify(_obj));
    that.com.Go("/tabs/contact/ScanningHoming/view/" + this.com.getNowDatetime,{
      FK_TBActivity_ID:that.activityID,
      activityName:that.activityName
    })
  }
 
    //  that.com.href("/tabs/contact/ScanningHoming/view/" + that.com.getNowDatetime);

    //#region  扫码下单
//     if (that.base.GridArrayData.length <= 0) {
//       that.msg.Alert("请扫码添加产品");
//       that.baseService.FixedSubmitBtn.isSubmitData = true;
//       return;
//     }
//     if (that.DisabledSubmit) {
//       that.baseService.FixedSubmitBtn.isSubmitData = true;
//       return;
//     }
//     that.DisabledSubmit = true;
//         let DataList: Array<any> = new Array<any>();
//         let lpArray:Array<any>=new Array<any>();//礼品列表
//        //#region 产品列表
//         that.base.GridArrayData.forEach(item => {
//           let array = {};
//           array["a_FK_TBProductInformation_ID"] = item.id;
//           array["a_Num"] = item.num;
//           array["a_productCode"] = item.code;
//           array["a_FK_TBActivity_ID"] = that.FK_TBActivity_ID;
//           array["IntegralCodeDetailList"]=item.IntegralCodeDetailList;
//           DataList.push(array);
//         });
//        //#endregion
//         //#region  礼品
//           that.tempGridList.forEach(p=>{
//             let c:any={};
//             c["id"]=p.id;
//             c["count"]=p.Num;
//             lpArray.push(c);
//           });
//         //#endregion
  
//     const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
//     let body = new WebParameterContext();
//     body.Account = that.com.GetAccount;
//     body.ConfigName = "ProductPurchaseRecordXML";
//     body.OpType = "add";
//     body.ConfigType = "form";
//     body.RowsPerPage = app.RowsPerPage;
//     body.PageNumber = 0;
//     body.Client.PageName = PageName;
//     body.Client.ApiType = "Element";
//     body.Client.Name = that.element.name;
//     body.Client.ClientType = 2;
//     if (that.platform.is("android")) {
//       body.Client.ClientType = 0;
//     } else if (that.platform.is("ios")) {
//       body.Client.ClientType = 1;
//     }
//     let _obj={"giftData":lpArray,"productData":DataList,"memberID":""};
//     body.RequestBody = JSON.stringify(_obj);
//     console.log(body);
// that.msg.Loading("数据请求中...").then(loads=>{
//   that.http.post(app.DEFAULTURL, body).then(data => {
//     that.baseService.FixedSubmitBtn.isSubmitData = true;
//     that.DisabledSubmit = false;
//     loads.dismiss();
//     /****判断是否第一页end****/
//     if (data.ResponseMessage.Success) {
//       that.base.GridArrayData = new Array<any>();
//       that.base.GridListCount = 0;
//       console.log(data);
//       localStorage.setItem("ordermarstID",data.Status.OrderId);
//          that.com.setHistoryUrl();
//          that.com.goQrCode(data.Status.QRCodeLink,"activityOrder","订单二维码");
//       // that.native.QRCodeinfo(that.qrcode.nativeElement, data.Status);
//     } else {
//       that.msg.Alert(data.ResponseMessage.ErrorMessage);
//     }
//   }).catch(error => {
//     that.baseService.FixedSubmitBtn.isSubmitData = true;
//     loads.dismiss();
//     that.DisabledSubmit = false;
//     console.log(error);
//     that.msg.Alert(error.ResponseMessage.ErrorMessage);
//   });
//     loads.present();
//     });
    //#endregion
  }


  async presentAlertCheck(PageName) {
    const that = this;
    let isplatform:boolean = false;
     if(that.platform.is("cordova")){
      if(that.platform.is("android")){
        if(that.device.version){
          if(that.device.version.toString().startsWith("4")){
            isplatform=true;
          }else if(that.device.version.toString().startsWith("3")){
            isplatform=true;
          }else if(that.device.version.toString().startsWith("2")){
            isplatform=true;
          }
        }
      }
     };
     if(that.com.IsWeixinBrowser){//如果是微信客户端调用微信
      isplatform=false;
     }
     if(isplatform){
      if(window.confirm("请选择扫码方式,【确定】表示扫码,【取消】表示手动输入")){
        // that.com.setHistoryUrl();
        that.scanQrcode(PageName);
       }else{
        var code= window.prompt("请输入产品罐码/箱码","");
        if(code){
          let _obj = {};
          _obj["Code"] = code;
          that.LoadDataBind(_obj);
        }else{
          that.msg.Alert("编码不能为空！");
        }
       }
     }else{
      const alert = await this.alertController.create({
        header: '系统提示',
        message:"请选择方式",
        mode:"ios",
        cssClass:"more-btn",
        buttons: [
          {
            text: "扫码识别",
            cssClass: 'btn-okay btn-width',
            handler: (Okay = "1") => {
              // console.log(Okay,"ok");
              // that.com.setHistoryUrl();
              that.scanQrcode(PageName);
            }
          },
          {
            text: "手动输入",
            cssClass: 'btn-okay btn-width',
            handler: (Okay1 = "2") => {
              // console.log(Okay1,"ok1");
              that.presentAlertInput();
            }
          },
          {
            text: "取消",
            role: 'cancel',
            cssClass: 'secondary btn-cancel btn-width',
            handler: (cancel) => {
              console.log(cancel,"cancel");
            }
          }
        ]
      });
      await alert.present();
     }
  }


  async presentAlertInput() {
    const that = this;
    const alert = await this.alertController.create({
      header: '请输入产品罐码/箱码',
      mode:"ios",
      inputs: [
        {
          name: 'a_Code',
          type: 'text',
          label: '请输入产品罐码/箱码',
          value: '',
          min: 6
        }
      ],
      buttons: [
        {
          text: "确认",
          cssClass: 'btn-okay',
          handler: (Okay) => {
            //console.log(Okay,"ok");
            if (Okay && Okay["a_Code"]) {
              let _obj = {};
              _obj["Code"] = Okay["a_Code"];
              that.LoadDataBind(_obj);
            } else {
              that.msg.Alert("编码不能为空！");
            }

          }
        },
        {
          text: "取消",
          role: 'cancel',
          cssClass: 'secondary btn-cancel',
          handler: (cancel) => {
            //console.log(cancel,"cancel");
          }
        }
      ]
    });

    await alert.present();
  }
    /**
   * 扫码
   * @param PageName 
   */
  scanQrcode(PageName) {
    const that = this;

    if (that.platform.is('cordova')) {
      // that.com.setHistoryUrl();
      that.barcode.scan().then((scan) => {
        let sancanArray: Array<any> = new Array<any>();
        sancanArray = that.com.GetStorageKey("backurl") || [];
        sancanArray.splice(sancanArray.length - 1, 1);
        localStorage.setItem("backurl", JSON.stringify(sancanArray));
        if (PageName) {
          if (PageName == "ScanCodeSales") {
            let _obj = {};
            if(scan.text){
              _obj["Code"] = scan.text;
              that.LoadDataBind(_obj);
            }
          }
        }
      }).catch(error => {
        that.msg.Show(error);
      });
    } else {
      if(that.com.IsWeixinBrowser){
        that.weixin.GetWxScanQRCode().then(data=>{
          // alert("扫码销量");
          let _obj = {};
            _obj["Code"] = data.Status;
            console.log(JSON.stringify(_obj),"返回二维码编码");
            // alert(JSON.stringify(_obj));
            that.LoadDataBind(_obj);
        }).catch(err=>{
          that.msg.Show(err.ResponseMessage.ErrorMessage, "middle");
        });
      }else{
        that.msg.Show("暂不支持", "middle");
      }
    }
  }
  LoadDataBind(obj: any) {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
        body.ConfigName = "ScanCodeXML";// "TBProductInformationXML";//产品名称
        body.OpType = "query";
        body.ConfigType = "view";
        body.RowsPerPage = app.RowsPerPage;
        body.PageNumber = 1;
        body.Client.PageName = PageName;
        body.Client.ApiType = "Element";
        body.Client.Name = "element";
        body.Client.ClientType = 2;
        if (that.platform.is("android")) {
          body.Client.ClientType = 0;
        } else if (that.platform.is("ios")) {
          body.Client.ClientType = 1;
        }
        body.RequestBody = JSON.stringify(obj);
    console.log(body,"请求接口");
    that.msg.Loading("数据请求中...").then(loads=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        console.log("data数据数据888888")
        console.log("data数据数据888888",data)
        loads.dismiss();
        if (data.ResponseMessage.Success) {
  
          let isproduct: boolean = false;
          if (that.base.IntegralCodeDetailList.length > 0) {
            that.base.IntegralCodeDetailList.forEach(pc => {
              if (pc == obj.Code) {
                isproduct = true;
              }
            });
            if (isproduct) {
              that.msg.Alert("已录入，请勿重复录入");
              return;
            } else {
              that.base.IntegralCodeDetailList.push(obj.Code);
            }
          } else {
            that.base.IntegralCodeDetailList.push(obj.Code);
          }
          let _data = {};
          _data["id"] = data.Status.productId;
          _data["name"] = data.Status.productname;
          _data["num"] = data.Status.Count;
          _data["code"] = data.Status.productCode;
          // _data["Code"]=obj.Code;
          // if(data.Status.IntegralCodeDetailList){
          //   data.Status.IntegralCodeDetailList.forEach(pro=>{
          //     if(pro.LogisticsCode){
          //       that.logisticsCode.push(pro.LogisticsCode);
          //     }
          //   });
          // }
          _data["IntegralCodeDetailList"] = data.Status.IntegralCodeDetailList;
          let isproductnum: boolean = false;
          that.base.GridArrayData.forEach(item => {
            if (item.id == data.Status.productId) {
              data.Status.IntegralCodeDetailList.forEach(items => {
                item.IntegralCodeDetailList.push(items);
              });
              let coun1: number = item.num;
              let count2: number = data.Status.Count;
              let count3: number = coun1 + count2;
              item.num = count3;
              isproductnum = true;
            }
          });
          if (!isproductnum) {
            that.base.GridArrayData.push(_data);
          }
          let sumNum: number = data.Status.Count;
          that.base.GridListCount += sumNum;
          console.log(that.base.GridArrayData,"处理完毕");
        } else {
          if (data.ResponseMessage.ErrorMessage) {
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          } else {
            that.msg.Alert("该编码不存在！");
          }
        }
      }).catch(error => {
        console.log(error);
        loads.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
      })
      loads.present();
    })
  }


  // 礼品弹窗
  async presentModal1() {
    console.log("fnengnkrwngnkwnbgr");
    let that = this;
    let ids:Array<string>=new Array<string>();
    // if(that.base.GridArrayData.length<=0){
    //   that.msg.Alert("请先操作【扫码销量】");
    //   return;
    // }
    that.base.GridArrayData.forEach(item => {
     
      console.log(item.id)
      ids.push(item.id);
      console.log("item.id--------------------------")
    });
    let checkitem:Array<any>=new Array<any>();
    that.tempGridList.forEach(temp=>{
      // 注释 pid  为了处理两个id相同产品处理
      checkitem.push({"id":temp.id,"Name":temp.Name,"Code":temp.Code,"Num":temp.Num,"pid":temp.pid});
      // checkitem.push({"id":temp.id,"Name":temp.Name,"Code":temp.Code,"Num":temp.Num});
      console.log("checkitem++++++++++++++++++")
      console.log(checkitem)
    });
    const modal = await that.modalCtrl.create({
      component: PublicselectionPage,
      componentProps: {
        "ids": ids,
        "checkItem":checkitem,
        "checked":that.ischeckAll,
        "codetype":0,
        "a_TelPhone":that.a_TelPhone
      }
    });
    await modal.present();
    // return await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    that.lpArrayList=[];
    if(data.result.ResponseMessage.Success){
       let tempList:Array<any>=new Array<any>();
            tempList=data.result.Status;
            that.ischeckAll=data.checked;
        that.base.GridGiftCount=0;
        that.tempGridList=tempList;
        // that.tempGridList.forEach(item=>{
        //   if(that.lpArrayList.find(proc=>proc.id==item.id)){
        //     that.lpArrayList.find(proc=>proc.id==item.id).NewNum+=item.Num;
        //   }else{
        //     item.NewNum=item.Num;
        //     that.lpArrayList.push(item);
        //   }
        // });
        
    }
    console.log(data,"onWillDismiss");
  }
  /**
   * 样品选择弹窗
   */
  async seletionModal() {
    console.log("样品选择");
    let that = this;
    let ids:Array<string>=new Array<string>();
    // if(that.base.GridArrayData.length<=0){
    //   that.msg.Alert("请先操作【扫码销量】");
    //   return;
    // }
    that.base.GridArrayData.forEach(item => {
      ids.push(item.id);
    });
    let checkitem:Array<string> = new Array<string>();
    that.tempGridgifList.forEach(itemp =>{
      checkitem.push(itemp.id);

    })
    const modal = await that.modalCtrl.create({
      component: SelectionpagePage,
      componentProps: {
        'ids': ids,
        "checkItem":checkitem,
        "checked":that.ischeckAllg
      }
    });
    await modal.present();
    // return await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    console.log(data,"onWillDismiss");
    if(data.result.ResponseMessage.Success){
      let tempgiftList:Array<any> = new Array<any>();
      tempgiftList = data.result.Status;
      that.ischeckAllg = data.checked;
      that.base.GridGiftNumber=0;
      that.tempGridgifList=tempgiftList;
      that.tempGridgifList.forEach(po=>{
        that.base.GridGiftNumber+=po.Num;
      });
    }
  }
  /**
   * 底部弹出删除
   */

  presentActionShee(itmid,index){
    const that = this;
    // debugger;
    that.msg.Confirm("确定删除吗?","取消","确定").then(fit=>{
      if(fit){
        /**
         * 判断两个相同的id相同删除产品
         */
        // if(that.tempGridList.length >0){
        //   let _index=that.tempGridList.length;
        //   while(_index--){
        //     if(that.tempGridList[_index].id == itmid.id){
        //       that.tempGridList.splice(_index, 1); 
        //     }
        //   }
        //   if(that.com.GetStorageKey("homing")){
        //     localStorage.setItem("homing",JSON.stringify(that.tempGridList));
        //   }
        //   // that.tempGridList=that.tempGridList.splice( that.tempGridList.findIndex(item => item.id ==itmid), 1); 
        // }
        // if(that.lpArrayList.length >0){
        //   that.lpArrayList.splice(index,1);
        //   if(that.com.GetStorageKey("lpArrayList")){
        //     localStorage.setItem("lpArrayList",JSON.stringify(that.lpArrayList));
        //   }
        // }

        // if(that.tempGridList.length >0){
        //   that.tempGridList.splice(index,1);
        //   localStorage.setItem("tempGridList",JSON.stringify(that.tempGridList));
        // }else{
        //   localStorage.removeItem("tempGridList");
        // }
        
        if(that.tempGridList.length >0){
          that.tempGridList.splice(index,1);
          if(that.com.GetStorageKey("homing")){
            localStorage.setItem("homing",JSON.stringify(that.tempGridList));
          }
        }
       

      }
    });

     
    }
    
  
  // async presentActionSheet(itmid,index) {
  //   const that = this;
  //   console.log("itmiditmiditmiditmiditmiditmiditmid")
  //   console.log(itmid)
  //   const actionSheet = await this.actionSheetCtrl.create({
  //     // header: 'Albums',
  //     buttons: [{
  //       text: '删除',
  //       role: 'destructive',
  //       icon: 'trash',
  //       handler: () => {
  //         // 删除礼品
        
         
  //       }
  //     }, 
  //     {
  //       text: '取消',
  //       icon: 'close',
  //       role: 'cancel',
  //       handler: () => {
  //         console.log('Cancel clicked');
  //       }
  //     }]
  //   });
  //   await actionSheet.present();
  // }
  async presentModaldifferences() {
    var that=this;
    // debugger;
    let _id="";
    if( that.com.GetStorageKey("activityName")){
      _id = that.com.GetStorageKey("activityName").activityID;
    }
    if(that.activityID){
      _id= that.activityID;
    }
    
    const modal = await this.modalCtrl.create({
      component: ListofActivitiesPage,
      cssClass: 'listof-activities',
      componentProps: {
        "type":"扫码归巢",
        "activityListArrayList":that.activityListArray, 
        "activeID":_id
      }
    });
      await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data)
    if(data.seceltName){
      that.activityName = data.seceltName;
      that.activityID = data.FK_TBReasonsProductInventoryDifferences_ID;
      
      if( that.activityName!==that.com.GetStorageKey("activityName")){
        // that.tempGridList= [];
        that.com.removeItem(["activityName"]); 
      }
      let _obj = {
        activityName:that.activityName,
        activityID:that.activityID
      }
      localStorage.setItem("activityName",JSON.stringify(_obj));
    }
    console.log(data.cravingforRemk)
   console.log(data.FK_TBReasonsProductInventoryDifferences_ID)
  }
  // 清楚选择的活动
  cleashideModal(){
    const that=this;
    that.activityName ="请选择活动";
    // that.tempGridList= [];
    that.activityID ="";
    that.com.removeItem(["activityName"]); 
  }
}
